export default __webpack_public_path__ + "static/media/loading.b8cc81c4.gif";